import React from "react";
import styled from "styled-components";
import { SectionEyebrow, SectionTitle, SectionDescription } from "../common/Section";

const Section = styled.section`
  padding: clamp(3rem,5vw,4.5rem) 8vw;
  border-top: 1px solid var(--ink-06);
  @media (max-width: 480px) { padding-left: 5vw; padding-right: 5vw; }
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: minmax(0,.9fr) minmax(0,1.1fr);
  gap: 24px; align-items: end; margin-bottom: 28px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px,1fr));
  gap: 16px;
  @media (max-width: 480px) { grid-template-columns: repeat(2,1fr); }
`;

const Card = styled.div`
  padding: 24px 20px;
  border: 1px solid var(--ink-08);
  background: rgba(255,255,255,.02);
  display: grid; place-items: center; gap: 12px; text-align: center;
  span { font-size: 12px; letter-spacing: .1em; text-transform: uppercase; color: var(--muted); }
`;

const Logo = styled.div`
  height: 40px; display: flex; align-items: center; justify-content: center;
  color: var(--ink);
  font-family: "DM Serif Display", serif;
  font-size: 18px; letter-spacing: .08em; opacity: .85;
`;

const partners = [
  { name: "Sony Music", role: "Publishing ecosystem" },
  { name: "Universal", role: "Distribution network" },
  { name: "Warner", role: "Label services ecosystem" },
  { name: "BMG", role: "Rights management" },
  { name: "ASCAP", role: "Performance rights" },
  { name: "BMI", role: "Performance rights" },
];

const HomeIndustry: React.FC = () => (
  <Section>
    <Header>
      <div>
        <SectionEyebrow>Industry ecosystem</SectionEyebrow>
        <SectionTitle>Where RMS operates.</SectionTitle>
      </div>
      <SectionDescription>
        RMS works within the major label, independent publishing, and global
        distribution ecosystem to deliver releases with reach and rights integrity.
      </SectionDescription>
    </Header>
    <Grid>
      {partners.map((p) => (
        <Card key={p.name}>
          <Logo>{p.name}</Logo>
          <span>{p.role}</span>
        </Card>
      ))}
    </Grid>
  </Section>
);

export default HomeIndustry;
